<template>
  <div class="sidebar-overlay" @click.self="$emit('close-menu')">
    <!-- <div class="triangle-wrapper">
      <div class="triangle-with-shadow"></div>
    </div> -->
    <div class="sidebar-content">
      <a
        class="test"
        rel="noopenner noreferer"
        href="https://app.contafacil.pe/#!/registro"
        @click="emitGlobalTriggerGtag('prueba_gratis')"
        >Prueba Gratis</a
      >
      <a
        class="login"
        rel="noopenner noreferer"
        href="https://app.contafacil.pe/#/login"
        @click="emitGlobalTriggerGtag('pre_ingreso')"
        >Ingresar</a
      >
      <a
        :class="{ 'link-active': $route.name == 'Home' }"
        class="link-sidebar"
        @click.stop="toView({ name: 'Home' })"
        >Inicio <span class="icon-plus">+</span></a
      >

      <details>
        <summary>
          <span class="link-sidebar link-sidebar--summary"
            >Cómo funciona <span class="icon-plus">+</span></span
          >
        </summary>
        <a
          :class="{ 'link-active': $route.name == 'sales' }"
          class="link-sidebar link-sidebar--inner"
          @click.stop="toView({ name: 'sales' })"
          >Ventas <img src="../assets/images/icons/icon-ventas.png" alt="" />
        </a>
        <!-- 
        <a
          :class="{ 'link-active': $route.name == 'marketrates' }"
          class="link-sidebar link-sidebar--inner"
          @click.stop="toView({ name: 'marketrates' })"
          >Cotizaciones
          <img src="../assets/images/icons/icon-cotizaciones.png" alt
        /></a>

        <a
          :class="{ 'link-active': $route.name == 'referralguide' }"
          class="link-sidebar link-sidebar--inner"
          @click.stop="toView({ name: 'referralguide' })"
          >Guías de Remisión
          <img
            src="../assets/images/icons/icon-guiasremision.png"
            alt
            class="logo"
        /></a> -->

        <a
          :class="{ 'link-active': $route.name == 'client-provider' }"
          class="link-sidebar link-sidebar--inner"
          @click.stop="toView({ name: 'client-provider' })"
          >Clientes y proveedores
          <img
            src="../assets/images/icons/icon-clientesproveedores.png"
            alt
            class="logo"
        /></a>

        <a
          :class="{
            'link-active': $route.name == 'expenses-purchases'
          }"
          class="link-sidebar link-sidebar--inner"
          @click.stop="toView({ name: 'expenses-purchases' })"
          >Gastos y compras
          <img
            src="../assets/images/icons/icon-gastoscompras.png"
            alt
            class="logo"
        /></a>
        <a
          :class="{ 'link-active': $route.name == 'inventory' }"
          class="link-sidebar link-sidebar--inner"
          @click.stop="toView({ name: 'inventory' })"
          >Inventario
          <img src="../assets/images/icons/icon-inventario.png" alt class="logo"
        /></a>

        <a
          :class="{ 'link-active': $route.name == 'reports' }"
          class="link-sidebar link-sidebar--inner"
          @click.stop="toView({ name: 'reports' })"
          >Reportes
          <img src="../assets/images/icons/icon-reportes.png" alt class="logo"
        /></a>
      </details>
      <a
        :class="{ 'link-active': $route.name == 'plans' }"
        class="link-sidebar"
        @click.stop="toView({ name: 'plans' })"
        >Planes <span class="icon-plus">+</span></a
      >

      <!-- <a
        :class="{ 'link-active': $route.name == 'blog' }"
        class="link-sidebar"
        @click.stop="toView({ name: 'blog' })"
        v-if="false"
        >Blog <span class="icon-plus">+</span></a
      > -->
      <a
        :class="{ 'link-active': $route.name == 'contact' }"
        class="link-sidebar"
        @click.stop="toView({ name: 'contact' })"
        >Contacto <span class="icon-plus">+</span></a
      >
      <a
        class="link-sidebar"
        href="https://consultas.contafacil.pe/"
        target="_blank"
        rel="noopenner noreferer"
        >Consulta CPE</a
      >
      <a
        :class="{ 'link-active': $route.name == 'support' }"
        class="link-sidebar"
        @click.stop="toView({ name: 'support' })"
        v-if="false"
        >Soporte <span class="icon-plus">+</span></a
      >
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";
export default {
  name: "SideBar",
  methods: {
    toView(path) {
      this.$router.push({ name: path.name });
      this.$emit("close-menu");
    },
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar-overlay {
  position: absolute;
  top: 64px;
  right: 5px;
  border-radius: 20px;
  box-shadow: 0px 0px 5px 2px rgba($color: #999999, $alpha: 0.7);
  overflow: hidden;
  z-index: 1;
  .triangle-wrapper {
    // position: absolute;
    // top: -48px;
    // left: 67px;
    .triangle-with-shadow {
      width: 50px;
      height: 50px;
      margin-left: 10px;
      position: relative;
      overflow: hidden;
      box-shadow: 0 0px 10px -17px rgba(0, 0, 0, 0.5);
    }
    .triangle-with-shadow:after {
      content: "";
      position: absolute;
      width: 25px;
      height: 25px;
      background: #ffffff;
      transform: rotate(45deg);
      top: 37px;
      left: 16px;
      box-shadow: -1px -1px 2px -2px rgba(0, 0, 0, 0.5);
    }
  }
  @media (min-width: 1024px) {
    display: none;
  }
}
.sidebar-content {
  background-color: #ffffff;
  min-width: 250px;
  padding: 1rem;
  margin-left: auto;
  summary {
    color: #6d6e70;
    text-align: end;
    display: flex;
    justify-content: flex-end;
    font-weight: bold;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    // margin-right: 1em;
    // padding-left: 1rem;
  }
  summary::-webkit-details-marker {
    display: none;
  }

  // summary:after {
  //   float: right;
  //   height: 20px;
  //   width: 20px;
  //   content: "+";
  //   font-size: 15px;
  //   color: #1fb3ac;
  //   font-weight: bold;
  //   text-align: center;
  //   margin-left: 1em;
  // }
  // details[open] summary:after {
  //   content: "-";
  //   float: right;
  //   color: #1fb3ac;
  // }
  a {
    display: block;
    font-size: 18px;
    // margin: 0.8rem auto;
  }
  .icon-plus {
    font-size: 15px;
    color: #1fb3ac;
  }
  .link-sidebar {
    color: #6d6e70;
    text-align: end;
    padding-left: 1rem;
    font-weight: bold;
    margin: 0.65rem auto;
    // &:not(.link-sidebar--inner):after {
    //   text-align: center;
    //   float: right;
    //   height: 20px;
    //   width: 20px;
    //   content: "+";
    //   font-size: 15px;
    //   color: #1fb3ac;
    //   font-weight: bold;
    //   margin-left: 1em;
    // }
    &--summary {
      margin: 0px;
      font-size: 18px;
    }
    &--inner {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 15px;
      img {
        margin-left: 1em;
        width: 20px;
      }
    }
  }
  .link-active {
    color: #1fb3ac;
    font-weight: bold;
  }
  .test {
    background-color: #1fb3ac;
    border: thin solid #1fb3ac;
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 5px;
    margin-bottom: 1rem;
    font-weight: bold;
    &:hover {
      background-color: #ffffff;
      color: #1fb3ac;
    }
  }
  .login {
    margin-bottom: 1rem;
    border: thin solid #1fb3ac;
    background-color: #ffffff;
    color: #1fb3ac;
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 5px;
    &:hover {
      color: #ffffff;
      background-color: #1fb3ac;
    }
  }
}
</style>
